<div class="container">
  <div class="col-md-12">
    <!-- Header -->
    <div class="tractor-header">
      <div class="tractor-header-content">
        <!-- Profile Picture Section -->
        <div class="tractor-image-section" [class.editable]="isEditMode">
          <img [src]="profilePicture" alt="Trailer Photo" class="tractor-profile-image" />
          <div *ngIf="isEditMode" class="image-overlay" (click)="profilePictureInput.click()">
            <div class="overlay-content">
              <i class="fa fa-camera"></i>
              <span>Change Photo</span>
            </div>
          </div>
          <input
            type="file"
            #profilePictureInput
            accept="image/*"
            (change)="onProfilePictureSelected($event)"
            style="display: none"
          />
        </div>

        <!-- Trailer Info Section -->
        <div class="tractor-info-section">
          <div class="tractor-name-row">
            <h2 class="tractor-name">
              {{
                isNewTrailer
                  ? "New Trailer"
                  : "TRAILER NUMBER: " + (trailer.trailerNo || trailer.unitNumber || "N/A")
              }}
            </h2>
            <span *ngIf="!isNewTrailer" [ngClass]="getStatusPillClass()">
              {{ getTrailerStatusLabel() }}
            </span>
          </div>
          <div class="tractor-basic-info">
            <div class="info-item">
              <strong>ASSIGNED DRIVER:</strong>
              {{ getAssignedDriverName() }}
            </div>
            <div class="info-item">
              <i class="fa fa-map-marker"></i>
              {{ getLocationInfo() }}
            </div>
            <div
              class="info-item"
              *ngIf="trailer?.fleetillaLocationUpdatedUtc"
              [style.color]="isFleetillaLocationStale() ? '#dc3545' : ''"
              [title]="getFleetillaLastUpdatedTooltip()"
            >
              <i class="fa fa-clock-o"></i>
              {{ getFleetillaLastUpdated() }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex" style="justify-content: space-between; align-items: center">
      <ul class="nav nav-tabs" role="tablist">
        <li *ngIf="canViewProfileTab()" class="nav-item" [class.active]="selectedTab === 'profile'">
          <a class="nav-link" (click)="onTabClicked('profile')" aria-label="Navigate to Profile tab"
            >PROFILE</a
          >
        </li>
        <li *ngIf="canViewSpecsTab()" class="nav-item" [class.active]="selectedTab === 'specs'">
          <a class="nav-link" (click)="onTabClicked('specs')" aria-label="Navigate to Specs tab"
            >SPECS</a
          >
        </li>
        <li *ngIf="canViewLicenseTab()" class="nav-item" [class.active]="selectedTab === 'license'">
          <a class="nav-link" (click)="onTabClicked('license')" aria-label="Navigate to License tab"
            >LICENSE</a
          >
        </li>
        <li
          *ngIf="canViewMaintenanceTab()"
          class="nav-item"
          [class.active]="selectedTab === 'maintenance'"
        >
          <a
            class="nav-link"
            (click)="onTabClicked('maintenance')"
            aria-label="Navigate to Maintenance tab"
            >MAINTENANCE</a
          >
        </li>
        <li
          *ngIf="canViewTripDocumentsTab()"
          class="nav-item"
          [class.active]="selectedTab === 'tripDocuments'"
        >
          <a
            class="nav-link"
            (click)="onTabClicked('tripDocuments')"
            aria-label="Navigate to Trip Documents tab"
            >TRIP DOCUMENTS</a
          >
        </li>
      </ul>
    </div>

    <div class="tab-content white-bg-tabs">
      <div *ngIf="selectedTab === 'profile' && canViewProfileTab()">
        <app-trailer-profile
          [trailer]="trailer"
          [isEditMode]="isEditMode && canEditProfileTab()"
          [terminals]="terminals"
          [states]="states"
          [dateInputMask]="dateInputMask"
          (hasChanges)="onTabHasChanges($event)"
        ></app-trailer-profile>
      </div>
      <div *ngIf="selectedTab === 'specs' && canViewSpecsTab()">
        <app-trailer-specs
          [trailer]="trailer"
          [isEditMode]="isEditMode && canEditSpecsTab()"
          (hasChanges)="onTabHasChanges($event)"
        ></app-trailer-specs>
      </div>
      <div *ngIf="selectedTab === 'license' && canViewLicenseTab()">
        <app-trailer-license
          [trailer]="trailer"
          [isEditMode]="isEditMode && canEditLicenseTab()"
          [states]="states"
          [dateInputMask]="dateInputMask"
          (hasChanges)="onTabHasChanges($event)"
        ></app-trailer-license>
      </div>
      <div *ngIf="selectedTab === 'maintenance' && canViewMaintenanceTab()">
        <app-trailer-maintenance
          [trailer]="trailer"
          [isEditMode]="isEditMode && canEditMaintenanceTab()"
          [dateInputMask]="dateInputMask"
          (hasChanges)="onTabHasChanges($event)"
        ></app-trailer-maintenance>
      </div>
      <div *ngIf="selectedTab === 'tripDocuments' && canViewTripDocumentsTab()">
        <app-trailer-trip-documents [trailerId]="trailer.id"></app-trailer-trip-documents>
      </div>
    </div>

    <!-- Footer -->
    <div class="tractor-footer">
      <div class="footer-left">
        <button
          *ngIf="!isNewTrailer && canEditAnyTab()"
          type="button"
          class="btn btn-danger"
          (click)="deleteTrailer()"
          [disabled]="isProcessing"
        >
          DELETE
        </button>
      </div>
      <div class="footer-right">
        <button
          *ngIf="isEditMode"
          type="button"
          class="btn btn-secondary"
          (click)="cancelEdit()"
          [disabled]="isProcessing"
        >
          Cancel
        </button>
        <button
          *ngIf="!isNewTrailer && canEditAnyTab()"
          type="button"
          class="btn btn-primary"
          (click)="toggleEditMode()"
          [disabled]="isProcessing"
        >
          {{ isEditMode ? "Save Changes" : "Edit Profile" }}
        </button>
        <button
          *ngIf="isNewTrailer"
          type="button"
          class="btn btn-primary"
          (click)="saveTrailer()"
          [disabled]="isProcessing"
        >
          Create Trailer
        </button>
      </div>
    </div>
  </div>
</div>
